/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Sderziehung11Inputs */

const en__field_enum_sderziehung11 = /** @type {(inputs: _Field_Enum_Sderziehung11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`04 - Erziehungswissenschaften`)
};

const de__field_enum_sderziehung11 = /** @type {(inputs: _Field_Enum_Sderziehung11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`04 - Erziehungswissenschaften`)
};

/**
* | output |
* | --- |
* | "04 - Erziehungswissenschaften" |
*
* @param {_Field_Enum_Sderziehung11Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_sderziehung11 = /** @type {((inputs?: _Field_Enum_Sderziehung11Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Sderziehung11Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_sderziehung11(inputs)
	return de__field_enum_sderziehung11(inputs)
});
export { _field_enum_sderziehung11 as "_field_enum_SDERZIEHUNG" }